<template>
  <span class="switch ml-2">
    <toggle-button :width="40" @change="onChangeEventHandler" :labels="false" />
  </span>
</template>

<script>
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "toggle-btn",
  components: {
    ToggleButton
  },
  methods: {
    onChangeEventHandler(data) {
      this.$emit("status", data.value);
    }
  }
};
</script>
<style scoped>
.vue-js-switch {
  margin-bottom: 0;
  float: right;
}
</style>
